<template>
  <div>
    <v-dialog/>
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">返回</a>
      字典<span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>
    </div>
    <form class="class_add_con w622 col_2_1 " data-vv-scope="form" style="width: 944px;">
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr class="tita">
          <td colspan="2" align="left" class="left_td" style="text-align:left;">字典基本信息</td>
        </tr>
        <tr>
          <td class="left_td pt30">键值：</td>
          <td class="pt20"><input type="text" v-validate="'required'" v-model="form.value" name="value" placeholder="请输入键值" class="put_495" style="width:180px;"/></td>
        </tr>
        <div class="error_msg">{{ errors.first('form.value') }}</div>
        <tr>
          <td class="left_td">标签：</td>
          <td><input type="text" name="label" v-validate="'required'" placeholder="请输入标签" class="put_495" style="width:180px;" v-model="form.label" /></td>
        </tr>
        <div class="error_msg">{{ errors.first('form.label') }}</div>
        <tr>
          <td class="left_td">类型：</td>
          <td><input type="text" name="labeltype" v-validate="'required'" placeholder="请输入类型" class="put_495" style="width:180px;" v-model="form.type"/></td>
        </tr>
        <div class="error_msg">{{ errors.first('form.labeltype') }}</div>
        <tr>
          <td class="left_td " valign="top">排序：</td>
          <td><input type="text" name="sort" v-validate="'required'" placeholder="请输入排序" class="put_495" style="width:180px;" v-model="form.sort" /></td>
        </tr>
        <div class="error_msg">{{ errors.first('form.sort') }}</div>
        <tr>
          <td class="left_td" style="padding-top: 20px;" valign="top">描述：</td>
          <td valign="top" class="pt10"><textarea name="description" cols="" rows="" class="text_area w490" v-model="form.description"></textarea></td>
        </tr>
        <div class="error_msg">{{ errors.first('form.description') }}</div>
      </table>
      <p class="btn_center mt50">
        <input name="" type="button" class="all_btn" value="提交完成" @click="validateForm('form')" />
      </p>
    </form>
    <div class="clear"></div>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  export default {
    data () {
      return {
        form: {}
      }
    },
    mounted () {
      if (this.isEdit) { // 通过 id 取信息并且要给select赋值
        this.getModel(this.$route.params.id)
      }
    },
    computed: {
      isEdit () {
        return this.$route.params.id && this.$route.params.id !== 'void'
      }
    },
    methods: {
      popup (msg) {
        this.$toasted.show(msg)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: this.$utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      validateForm (scope) {
        var bus = this
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            bus.confirmBox({
              yes: function () {
                api.post(config.bylBaseCenterPath, '/dict/edit', bus.form, function (r) { // 正常
                  if (bus.isEdit) { // 编辑
                    bus.popup('保存成功')
                  } else {
                    bus.popup('创建字典成功')
                  }
                  bus.$router.push('/platform/dictList')
                })
              }
            })
          } else {
            bus.popup('请确保信息正确与完整')
            return false
          }
        })
      },
      to (path) {
        this.$router.push(path)
      },
      getModel (id) {
        var that = this
        api.get(config.bylBaseCenterPath, '/dict/get', {id: id}, function (r) { // 正常
          that.form = r.data
          that.$emit('data-prepared', that.form)
        })
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/byl/org/orgdict/model.vue